import type { TFunction } from 'i18next';
import { toast } from 'sonner';
import { getBadRequestIssues, hasInquirerCompanyProfileIssue } from '@/lib/httpErrorMessage';

export function getInquirerCompanyProfileBlockedDescription(error: unknown, t: TFunction): string {
  const issues = getBadRequestIssues(error) ?? [];
  const lines = issues
    .map((issue) => issue.code)
    .filter((code): code is string => typeof code === 'string' && code !== '')
    .map((code) => t(`inquiries.companyProfile.issues.${code}`, { defaultValue: '' }))
    .filter((line) => line.trim() !== '');

  if (lines.length > 0) {
    return lines.join(' ');
  }
  return t('inquiries.companyProfile.blockedDescription');
}

/** Shows why review submit failed and how to fix the company profile. */
export function toastInquirerCompanyProfileBlocked(
  error: unknown,
  t: TFunction,
  openSettings: () => void,
): boolean {
  if (!hasInquirerCompanyProfileIssue(error)) {
    return false;
  }
  toast.error(t('inquiries.companyProfile.blockedTitle'), {
    description: getInquirerCompanyProfileBlockedDescription(error, t),
    action: {
      label: t('inquiries.companyProfile.openSettings'),
      onClick: openSettings,
    },
  });
  return true;
}
